import dayjs from 'dayjs';
import { List, ListItemButton, Typography, Fab } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import TypeIcon from './TypeIcon/TypeIcon';
import MarkIcon from './MarkIcon/MarkIcon';
import MarkIconDesc from './MarkIcon/MarkIconDesc';
import CurrMarksChart from './CurrMarksChart';

function getMjesec(datum) {
  if (!datum) return '';
  const m = dayjs(datum).format('MMM');
  if (m === 'May') return 'Maj';
  if (m === 'Oct') return 'Okt';
  return m;
}

function getDan(datum) {
  if (!datum) return '';
  return dayjs(datum).format('DD');
}

function getAvg(sum, cnt) {
  if (cnt === 0) return '';
  return Math.round((sum / cnt) * 100) / 100;
}

function getTekucaStatistika(marks) {
  const data = [
    { ocjena: '1', 'ukupan broj': 0 },
    { ocjena: '2', 'ukupan broj': 0 },
    { ocjena: '3', 'ukupan broj': 0 },
    { ocjena: '4', 'ukupan broj': 0 },
    { ocjena: '5', 'ukupan broj': 0 },
  ];
  let sum = 0, cnt = 0;
  marks.forEach((mark) => {
    if (['1','2','3','4','5'].includes(String(mark.ocjena))) {
      const o = parseInt(mark.ocjena);
      data[o - 1]['ukupan broj']++;
      cnt++;
      sum += o;
    }
  });
  return { data, avg: getAvg(sum, cnt) };
}

export default function MarksDetailsMUI({ marks = [], subject_name, onBack }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div>
      {!isMobile && (
        <div className="mark-details-header">
          <div className="mark-details-subject">
            <Typography variant="h6">{subject_name}</Typography>
          </div>
          <div>
            <Fab color="primary" size="small" variant="contained" onClick={onBack}>
              <FontAwesomeIcon icon={faArrowLeft} size="1x" />
            </Fab>
          </div>
        </div>
      )}

      <div className="marks-layout">
        <div className="marks-layout-left">
          <div className="marks-container">
            <List sx={{ p: 0, m: 0 }}>
              {marks.map((mark, index) => (
                <ListItemButton key={index} sx={{ p: 0, m: 0 }}>
                  <div className="main-flex-container">
                    <TypeIcon naziv={mark.nazivtipa} id={mark.id_tipa_ocjene} />
                    <div className="right-flex-container">
                      <div className="upper-flex-container">
                        <div className="main-text">{mark.nazivtipa}</div>
                      </div>
                      <div className="bottom-flex-container">
                        {mark.naziv_cilja
                          ? <MarkIconDesc mark={mark.ocjena} />
                          : <MarkIcon mark={mark.ocjena} />}
                      </div>
                      {mark.naziv_cilja && (
                        <div className="bottom-flex-container top-border">
                          {mark.naziv_cilja}
                        </div>
                      )}
                    </div>
                    <div className="date-container">
                      <div>{getDan(mark.datum)}</div>
                      <div>{getMjesec(mark.datum)}</div>
                    </div>
                  </div>
                </ListItemButton>
              ))}
            </List>
          </div>
        </div>
        <div className="marks-layout-right">
          <div className="chart-container">
            <CurrMarksChart data={getTekucaStatistika(marks)} is_complete={false} />
          </div>
        </div>
      </div>
    </div>
  );
}
